import { useEffect, useState } from 'react'
import GlassSurface from './GlassSurface'
import { Logo } from './Logo'

const LINKS = [
  { href: '#features', label: 'Features' },
  { href: '#roadmap', label: 'Roadmap' },
]

export function Nav() {
  const [scrolled, setScrolled] = useState(false)
  const isLive = import.meta.env.VITE_APPSTORE_LIVE === '1'
  const storeUrl = import.meta.env.VITE_APPSTORE_URL || ''
  const storeDirect = isLive && !!storeUrl

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? 'py-3' : 'py-6'
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="relative h-[64px]">
          {/* Centered glass pill — uses real liquid-glass refraction */}
          <div className="nav-pill absolute left-1/2 -translate-x-1/2 top-0">
            <GlassSurface
              width={300}
              height={64}
              borderRadius={9999}
              backgroundOpacity={0.45}
              brightness={20}
              blur={14}
              saturation={1.4}
            >
              <div className="flex items-center gap-6 pl-2 pr-6">
                <a
                  href="#top"
                  className="flex items-center gap-2 group"
                  aria-label="Ruvi home"
                >
                  <Logo className="w-11 h-11 rounded-2xl transition-transform duration-500 group-hover:rotate-[12deg]" />
                </a>
                <nav className="flex items-center gap-6">
                  {LINKS.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="text-[15px] text-ink-2 hover:text-ink-1 transition-colors"
                    >
                      {link.label}
                    </a>
                  ))}
                </nav>
              </div>
            </GlassSurface>
          </div>

          {/* Right floating CTA. When the app is live we link straight to the
              App Store listing in a new tab (no /#beta hop, no current-tab
              navigation). When not live, we route through /#beta which opens
              the waitlist overlay. Hidden below md — on phones the centered
              glass pill carries the brand and the footer CTA + body
              "App Store" buttons cover the conversion. */}
          <a
            {...(storeDirect
              ? { href: storeUrl, target: '_blank' as const, rel: 'noopener noreferrer' as const }
              : { href: '/#beta' })}
            className="nav-cta absolute right-0 top-0 hidden md:inline-flex items-center h-[64px] px-7 rounded-full bg-[var(--accent)] text-bg-0 text-[15px] font-semibold transition-transform hover:-translate-y-0.5 shadow-[0_10px_36px_-10px_var(--accent-ring)]"
          >
            Download
          </a>
        </div>
      </div>
    </header>
  )
}
